var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-navbar',{attrs:{"toggleable":"lg","type":"dark","variant":"info"}},[_c('b-container',{attrs:{"fluid":"md"}},[_c('b-navbar-brand',{staticClass:"fs-2",attrs:{"href":"#"}},[_vm._v("ZohoCheck")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }